module.exports = __webpack_public_path__ + "media/common/images/badges/gray/dotahovac-f2deb036c00cd9718dad30b846367eb1.svg";